import $ from 'jquery'

class HeaderGutenberg {
  // desktop
  private readonly MENU_ITEM_WITH_SUBMENU: string = '.menu-item-with-submenu'
  private readonly SUBMENU_CLASS_PREFIX: string = '.submenu-'
  private readonly ICON_BUTTONS_RIGHT_UL: string = '.icon-buttons'

  // mobile
  private readonly SEARCH_ICON_MOBILE: string = '.article-search-icon-mobile'
  private readonly SEARCH_FORM_MOBILE: string = '.article-search-form-mobile'
  private readonly SEARCH_CLOSE_ICON_MOBILE: string = '.article-search-form-close-icon-mobile'
  private readonly HAMBURGER_MOBILE: string = '.hamburger-mobile'
  private readonly CLOSE_ICON_MOBILE: string = '.close-icon-mobile'
  private readonly BACK_BUTTON_MOBILE: string = '.mobile-submenu-back-button'
  private readonly MAIN_PAGE_CONTENT: string = '#content'
  private readonly FOOTER: string = 'footer'
  private readonly MAIN_NAV_LINKS_SECTION_MOBILE: string = '.nav-links'
  private readonly NAV_CONTENT_MOBILE: string = '.nav-content-mobile'
  private readonly SUBMENU_CLASS_PREFIX_MOBILE: string = '.submenu-mobile-'
  private readonly MENU_ITEM_WITH_SUBMENU_MOBILE: string = '.mobile-menu-item-with-submenu'
  private readonly SUBMENU_CLASS_MOBILE: string = '.custom-sub-menu-mobile'
  private readonly BOTTTOM_BUTTON_CONTAINER: string = '.bottom-buttons-container'
  // private readonly WP_ADMIN_BAR: string = '#wpadminbar'
  // private readonly NAV_TOP_ROW_MOBILE: string = '.nav-top-row-mobile'

  private readonly SLIDE_DURATION: number = 250

  private getCustomMenuType($menuItem: JQuery): string {
    const classAttr = $menuItem.attr('class')
    if (!classAttr) return ''

    const classList = classAttr.split(/\s+/)
    let customType = ''

    classList.forEach((className: string) => {
      if (className.startsWith('submenu-type-')) {
        customType = className.replace('submenu-type-', '')
      }
    })
    return customType
  }

  private setupSubmenuHover() {
    const menuItemsWithSubmenu = $(this.MENU_ITEM_WITH_SUBMENU)

    menuItemsWithSubmenu.each((_: number, menuItem: HTMLElement) => {
      const $menuItem = $(menuItem)
      const menuCustomType = this.getCustomMenuType($menuItem)
      const submenuSelector = this.SUBMENU_CLASS_PREFIX + menuCustomType
      const $submenu = $(submenuSelector)

      if ($submenu.length) {
        // Show submenu on hover of main menu item
        $menuItem.on('mouseenter', () => {
          $submenu.css('display', 'block') // Display submenu without animation
        })

        // Keep submenu open when hovering over the submenu
        $submenu.on('mouseenter', () => {
          $submenu.css('display', 'block') // Keep submenu visible
        })

        // Hide submenu when mouse leaves both the main item and submenu
        $menuItem.on('mouseleave', () => {
          if (!$submenu.is(':hover')) {
            $submenu.css('display', 'none') // Hide submenu without animation
          }
        })

        $submenu.on('mouseleave', () => {
          $submenu.css('display', 'none') // Hide submenu without animation
        })
      }
    })
  }

  private setupMobileMenuActions() {
    const $hamburger = $(this.HAMBURGER_MOBILE)
    const $pageMainContent = $(this.MAIN_PAGE_CONTENT)
    const $footer = $(this.FOOTER)
    const $closeIcon = $(this.CLOSE_ICON_MOBILE)
    const $backButtons = $(this.BACK_BUTTON_MOBILE)
    const $mainNavigationLinksSection = $(this.MAIN_NAV_LINKS_SECTION_MOBILE)
    const $navContent = $(this.NAV_CONTENT_MOBILE)
    const $menuItemsWithSubmenu = $(this.MENU_ITEM_WITH_SUBMENU_MOBILE)
    const $submenus = $(this.SUBMENU_CLASS_MOBILE)
    const $bottomButtonsContainer = $(this.BOTTTOM_BUTTON_CONTAINER)
    let lastParentMenuItem: HTMLElement | null = null

    // Event listener for opening the mobile menu
    $hamburger.on('click', () => {
      $closeIcon.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $hamburger.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $pageMainContent.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $footer.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $mainNavigationLinksSection.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $navContent.removeClass('hidden-header-helper').addClass('flex-header-helper')
    })

    // Event listener for closing the mobile menu
    $closeIcon.on('click', () => {
      $closeIcon.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $hamburger.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $pageMainContent.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $footer.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $mainNavigationLinksSection.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $navContent.removeClass('flex-header-helper').addClass('hidden-header-helper')
      $submenus.removeClass('visible-header-helper').addClass('hidden-header-helper')
    })

    // Setting up submenu actions for mobile
    $menuItemsWithSubmenu.each((_, menuItem) => {
      const $menuItem = $(menuItem)
      const menuCustomType = this.getCustomMenuType($menuItem)
      const submenuSelector = this.SUBMENU_CLASS_PREFIX_MOBILE + menuCustomType
      const $submenu = $(submenuSelector)

      if ($submenu.length) {
        $menuItem.on('click', (e) => {
          e.preventDefault() // prevent page jump if needed
          lastParentMenuItem = menuItem // <-- Store parent menu item here!
          $submenu.removeClass('hidden-header-helper').addClass('visible-header-helper')
          $mainNavigationLinksSection.removeClass('visible-header-helper').addClass('hidden-header-helper')
          $bottomButtonsContainer.removeClass('flex-header-helper').addClass('hidden-header-helper')
          // Optionally, focus first item in submenu here
          setTimeout(() => {
            $submenu.find('button, [tabindex], a').filter(':visible').first().focus()
          }, 0)
        })
      }
    })

    // Event listener for back button in submenus
    $backButtons.on('click', (e) => {
      $submenus.removeClass('visible-header-helper').addClass('hidden-header-helper')
      $mainNavigationLinksSection.removeClass('hidden-header-helper').addClass('visible-header-helper')
      $bottomButtonsContainer.removeClass('hidden-header-helper').addClass('flex-header-helper')
      // Restore focus to lastParentMenuItem (the menu item that opened the submenu)
      if (lastParentMenuItem) {
        setTimeout(() => {
          ;(lastParentMenuItem as HTMLElement).focus()
        }, 0)
      }
    })
  }

  private setupSearchActions() {
    const $searchIconMobile = $(this.SEARCH_ICON_MOBILE)
    const $searchFormMobile = $(this.SEARCH_FORM_MOBILE)
    const $searchCloseIconMobile = $(this.SEARCH_CLOSE_ICON_MOBILE)
    const $iconButtons = $(this.ICON_BUTTONS_RIGHT_UL)
    const SLIDE_DURATION = this.SLIDE_DURATION

    // Show the search form
    function openSearchForm() {
      $searchFormMobile.css('display', 'flex')
      $iconButtons.css('display', 'none')
      // Focus input
      const input = $searchFormMobile.find('input[type="text"]')[0]
      if (input) (input as HTMLElement).focus()
    }

    // Hide the search form
    function closeSearchForm() {
      $searchFormMobile.fadeOut(SLIDE_DURATION, () => {
        $searchFormMobile.css({ display: 'none', width: 'initial' })
        $searchIconMobile.css('display', 'flex')
        $iconButtons.css('display', 'flex')
        if ($searchIconMobile.length) {
          ;($searchIconMobile[0] as HTMLElement).focus()
        }
      })
    }

    // Make the open search icon keyboard accessible
    $searchIconMobile.on('click', openSearchForm)
    $searchIconMobile.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        openSearchForm()
      }
    })

    // Make the close search icon keyboard accessible
    $searchCloseIconMobile.on('click', closeSearchForm)
    $searchCloseIconMobile.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        closeSearchForm()
      }
    })
  }

  private setupKeyboardSubmenuToggle() {
    // Keyboard navigation for desktop main menu with submenu
    const $menuLinks = $(this.MENU_ITEM_WITH_SUBMENU)

    $menuLinks.each((_, linkEl) => {
      const $link = $(linkEl)
      const $li = $link.closest('li')
      const $toggle = $link.next('.submenu-toggle')
      const menuCustomType = this.getCustomMenuType($link)
      const $submenu = $(this.SUBMENU_CLASS_PREFIX + menuCustomType)

      // Toggle submenu on Enter/Space
      $toggle.on('keydown click', (e) => {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          const isOpen = $submenu.is(':visible')
          if (!isOpen) {
            $submenu.css('display', 'block')
            $toggle.attr('aria-expanded', 'true')
            setTimeout(() => {
              const $firstSubItem = $submenu.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first()
              if ($firstSubItem.length) {
                $firstSubItem[0].focus()

                // Set handlers for tab-out
                const $subItems = $submenu.find('a, button, input, [tabindex]:not([tabindex="-1"])').filter(':visible')
                $subItems
                  .last()
                  .off('keydown')
                  .on('keydown', function (e) {
                    if (e.key === 'Tab' && !e.shiftKey) {
                      e.preventDefault()
                      // Close submenu, focus next main menu item or icon-buttons
                      $submenu.css('display', 'none')
                      $toggle.attr('aria-expanded', 'false')

                      let $nextFocus = $li.next().find('.menu-item-with-submenu, .submenu-toggle, a').first()

                      if (!$nextFocus.length) {
                        // Focus the first focusable element in the icon-buttons
                        $nextFocus = $('.icon-buttons-right').find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first()
                      }
                      if ($nextFocus.length) {
                        $nextFocus[0].focus()
                      }
                    }
                  })

                $subItems.first().on('keydown', function (e) {
                  if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault()
                    // Close submenu, focus previous main menu item
                    $submenu.css('display', 'none')
                    $toggle.attr('aria-expanded', 'false')
                    const $prevFocus = $li.prev().find('.menu-item-with-submenu, .submenu-toggle, a').last()
                    if ($prevFocus.length) {
                      $prevFocus[0].focus()
                    }
                  }
                })
              }
            }, 0)
          } else {
            $submenu.css('display', 'none')
            $toggle.attr('aria-expanded', 'false')
          }
        }
      })
    })
  }

  private init = () => {
    // console.log('   DOM loaded. Initializing custom submenu behavior.')
    this.setupSubmenuHover()
    this.setupKeyboardSubmenuToggle()
    this.setupSearchActions()
    this.setupMobileMenuActions()
  }

  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    })
    // console.log('HeaderGutenberg() - Waiting for DOM to load')
  }
}

new HeaderGutenberg()
